import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const session_id = params.get("session_id");
    if (!session_id) { navigate("/login"); return; }

    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id });
        setUser(r.data.user);
        toast.success(`Welcome, ${r.data.user.name?.split(" ")[0]}!`);
        navigate("/", { state: { user: r.data.user } });
      } catch {
        toast.error("Sign-in failed");
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto rounded-full brand-gradient-pink animate-pulse"/>
        <p className="mt-4 text-slate-500 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
